import { useGLTF } from '@react-three/drei'

export default function Ground() {
    const { nodes } = useGLTF('./models/ground.glb')

    return (
        <mesh 
            geometry={nodes.ground.geometry}
            onClick={ (event) => event.stopPropagation() }
            onPointerEnter={ (event) => event.stopPropagation()}
        >
            <meshStandardMaterial color={0x392821} />
        </mesh>
    )
}
